import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import api from '../utils/api';

export class LabOrderFormDownload extends Component {
    constructor(props) {
      super(props);
    }

  downloadLabCorpForm(isNY) {
    api.downloadPDF('Lab/Form/' + (isNY ? "true" : "false"));
  }
    
  render() {
    return (<Fragment>
        <p style={{fontWeight: "bold"}}>LabCorp Order Form</p>
        <img src={`/Content/panels/clipboard.png`} alt='Lab Forms' style={{float: "left", marginRight: "8px"}}/>
        <p style={{marginTop: "15px", marginBottom: "30px"}}>Print the below form and take it with you to a Labcorp Patient Service Center, approved alternative lab site 
        (see below for locations) {this.props.isTEL ? <span>, or attend one of the onsite lab draws at a TEL location</span> : null}.
        </p>
        <div>
        <ul>
            {this.props.labFormDataId
            ? (<Fragment>
                <li><Button className="xs" color="light" onClick={() => this.downloadLabCorpForm(false)}>Download LabCorp Form - <span style={{color: "#FF0000"}}>all except NY</span></Button></li>
                <li><Button className="xs" color="light" onClick={() => this.downloadLabCorpForm(true)}>Download LabCorp Form - <span style={{color: "#FF0000"}}>NY</span></Button></li>
                </Fragment>)
            : null
            }
            <li><a href='https://www.labcorp.com/labs-and-appointments' target='_blank' rel="noopener noreferrer">LabCorp Locations/Appointments</a></li>
            <li><a href="/Content/PDF/Lab_Locations.pdf" target="_blank" rel="noopener noreferrer">Alternative Lab Locations</a></li>
        </ul>
        </div>
        <p style={{fontWeight: "bold"}}>HealthCare Provider Lab Form</p>
        {(this.props.isSunTrust || this.props.isBBT)
        ? (<p style={{marginLeft: "8px"}}>
            Truist covers the cost of blood work done by LabCorp or a <a href='https://www.mypremisehealth.com' target="_blank" rel="noopener noreferrer">Truist Health Clinic</a>. If you choose to have your lab work done by an approved alternative lab location, 
            Truist will cover the cost based on your medical plan. Opting to obtain your lab work from an unauthorized provider could result in missing labs that would not comply with 
            Peak Health lab requirements. The cost of lab work obtained from an unauthorized provider will be your responsibility.
            </p>)
        : null
        }
        {this.props.isTEL || this.props.isTELSpouse
        ? (<p style={{marginLeft: "8px"}}>
            If you choose to have required labs completed with your healthcare provider, 
            please <a href='/Content/PDF/TELLabInstructionsForm.pdf' target="_blank" rel="noopener noreferrer">download the HealthCare Provider Instructions Form here.</a>
            </p>)
        : null
        }
        </Fragment>);
    }
}